import { mdmGuard } from "../func"

// MDM 라우트 — management.js 트리 패턴 복제
// 최종 URL: /:lang/mdm/...  (모든 도메인 라우트는 /:lang 하위 children)
const mdmRouter = {
  path: "mdm",
  component: () => import("@/components/frame/main.vue"),
  children: [
    {
      path: "",
      name: "mdm",
      beforeEnter: mdmGuard,
      redirect: { name: "mdm-profiles" }, // 진입 → 기기정책 목록
      component: () => import("@/components/mdm/MdmLayout.vue"), // 좌측 사이드바 + router-view
      children: [
        {
          path: "profiles",
          name: "mdm-profiles",
          meta: { auth: ["Manager"] },
          component: () => import("@/components/mdm/profiles/MdmProfilePage.vue"),
          beforeEnter: mdmGuard,
        },
        {
          path: "apps/:platform",
          name: "mdm-apps",
          meta: { auth: ["Manager"] },
          component: () => import("@/components/mdm/apps/MdmAppPage.vue"),
          beforeEnter: mdmGuard,
        },
      ],
    },
  ],
}

export default mdmRouter
